import makeClickable from "../../common/makeClickable.js";

export default () => {
  document
    .querySelectorAll(".js-featured-promo-clickable")
    .forEach(makeClickable);
};
